/* eslint-disable */
import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import fingerScan from 'assets/gif/Finger_print_scanning.gif';
import { handleCapture } from 'views/Components/BiometricDevices/BiometricCapture';

const AepsAuthCaptureModal = ({ open, deviceName, onClose, onCaptureSuccess, onCaptureFailure }) => {
    const [authStatus, setAuthStatus] = useState('idle');

    useEffect(() => {
        if (deviceName) {
            setAuthStatus('scanning');
            const timeoutId = setTimeout(() => {
                handleCapture(deviceName, (data) => {
                    if (data && data !== false) {
                        setAuthStatus('success');
                        onCaptureSuccess(data);
                    } else {
                        setAuthStatus('error');
                        onCaptureFailure();
                    }
                });
            }, 1000);
            return () => clearTimeout(timeoutId);
        }
    }, [deviceName]);

    const renderStatus = () => {
        switch (authStatus) {
            case 'scanning':
                return (
                    <>
                        <img src={fingerScan} alt="Scanning" style={{ width: 80, height: 80 }} />
                        <Typography mt={2}>Scanning fingerprint...</Typography>
                    </>
                );
            case 'success':
                return (
                    <>
                        <CheckCircleIcon sx={{ fontSize: 80, color: 'green' }} />
                        <Typography mt={2}>Authentication successful</Typography>
                    </>
                );
            case 'error':
                return (
                    <>
                        <ErrorIcon sx={{ fontSize: 80, color: 'red' }} />
                        <Typography mt={2}>Authentication failed. Try again.</Typography>
                    </>
                );
            default:
                return (
                    <>
                        <FingerprintIcon sx={{ fontSize: 80, color: 'gray' }} />
                        <Typography mt={2}>Ready for scan</Typography>
                    </>
                );
        }
    };

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    onClose();
                }
            }}
        >
            <DialogTitle>Fingerprint Authentication</DialogTitle>
            <DialogContent>
                <Box textAlign="center" mt={2}>
                    {renderStatus()}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AepsAuthCaptureModal;
